import moment from "moment"
import React, { Component } from "react"
import EditReviewTypes from "../ReviewTypes/EditReviewTypes"
import "./DeleteReview.css"

interface DeleteReviewProps {
    manageParentState: Function
    updateReview: Function
    review: EditReviewTypes
    contextUser: string | number
    loading: boolean
}

interface DeleteReviewState {
    input: string
}

class DeleteReview extends Component<DeleteReviewProps, DeleteReviewState> {

    state = {
        input: ""
    }

    //!!!! ***Remove this and uncomment the modal in the render method to change this back to a delete nag*** */
    componentDidMount() {
        this.handleDelete()
    }
    //!!!! ************************************************************************************************** */

    handleChange = (event: { target: { value: string } }) => {
        let input = event.target.value
        this.setState({ input: input })
    }

    handleDelete = () => {
        let rb = this.props.review
        rb.DeletedDateUtc = moment(Date.now()).format().split("T")[0]
        rb.DeletedBy = this.props.contextUser
        this.props.updateReview(rb)
    }

    match = () => {
        let a = this.props.review.EmployeeReviewId.toString().trim()
        let b = this.state.input
        if (a === b) {
            return true
        }
        return false
    }

    render() {

        return (
            <div className="DeleteReview">
                {/* <Modal id="delete-review-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="DeleteReviewModalHeader">
                            <p>Type <span>{props.review.EmployeeReviewId}</span> to confirm.</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="DeleteReviewModalBody">
                            <div className="DeleteReviewDiscardNagBody">
                                <FormControl
                                    placeholder={"..."}
                                    onChange={this.handleChange}
                                    value={this.state.input || ""}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="DeleteReviewModalFooter">
                            {!props.loading && <Button variant="secondary" onClick={() => props.manageParentState([{ key: "confirmDelete" }])}>Cancel</Button>}
                            {!props.loading && <Button variant="danger" disabled={!this.match()} onClick={() => this.handleDelete()}>Delete</Button>}
                            {props.loading && <Spinner id="delete-review-load-spinner" animation="border" />}
                        </div>
                    </Modal.Footer>
                </Modal> */}
            </div>
        )
    }
}

export default DeleteReview